import styled from 'styled-components';

interface BrowserBrandHeaderProps {
  companyName: string;
}

const Header = styled.header`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 24px;
  border-bottom: 1px solid var(--screening-hairline);
  background: var(--screening-paper);
`;

const Avatar = styled.div`
  width: 34px;
  height: 34px;
  border-radius: var(--screening-r-input);
  background: var(--screening-navy);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--screening-font-display);
  font-size: 14px;
  font-weight: 700;
`;

const Name = styled.span`
  font-family: var(--screening-font-display);
  font-size: 16px;
  font-weight: 700;
  color: var(--screening-ink);
`;

export const initialsOf = (name: string): string =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join('') || '?';

/** Employer-branded header for candidate and board surfaces. No HireMe mark. */
const BrowserBrandHeader = ({ companyName }: BrowserBrandHeaderProps) => (
  <Header>
    <Avatar>{initialsOf(companyName)}</Avatar>
    <Name>{companyName}</Name>
  </Header>
);

export default BrowserBrandHeader;
